module.exports = __webpack_public_path__ + "static/Asta_Burbaite-690991821708bd10f6fb39392bd583e5.jpg";